import useDemoConfig from '../../pages/groups-dashboard/Table/CourseReport/useDemoConfig'
import React from "react";
import { AxisOptions, Chart } from "react-charts";

export default function BarHorizontal({ courseStats }) {


  const data = [
    {
      'label': 'In Progress',
      'data' : [{
        'primary': 'Course', 
        'secondary': courseStats[2].value,
      }]
    },
    {
      'label': 'Completed',
      'data' : [{
        'primary': 'Course', 
        'secondary': courseStats[1].value,
      }]
    },
    {
      'label': 'Not Started',
      'data' : [{
        'primary': 'Course', 
        'secondary': courseStats[3].value, 
      }]
    }
  ]
  
  const primaryAxis = React.useMemo<
    AxisOptions<typeof data[number]["data"][number]>
  >(
    () => ({
      position: "left",
      getValue: (datum) => datum.primary,
      show:false,
      elementType: 'bar'
    }),
    []
  );

  const secondaryAxes = React.useMemo<
    AxisOptions<typeof data[number]["data"][number]>[]
  >(
    () => [
      {
        position: "bottom",
        getValue: (datum) => datum.secondary,
        show:false,
        elementType: 'bar'
      },
    ],
    []
  );

  return (
    <>
      <div
        style={{
          width: `150px`,
          height: `110px`,
        }}>
        <Chart
          options={{
            data,
            primaryAxis,
            secondaryAxes,
            defaultColors: [ '#E3A008', '#0E9F6E', '#6B7280', /*In Progress, Completed, Not Started colors*/ ]
          }}
        />
      </div>
    </>
  );
}
